module.exports = __webpack_public_path__ + "static/media/hubita_contract_generating.9c176e95.gif";